import Head from "next/head";
import { make as TeamBuilderPage } from "../../src/team-planner-core/TeamPlannerPage.bs";
import { qsToTitle as qsToTitle10 } from "../../src/team-planner10/TbPage10.bs";
import { qsToTitle as qsToTitle13 } from "../../src/team-planner13/TbPage13.bs";
import { qsToTitle as qsToTitle14 } from "../../src/team-planner14/TbPage14.bs";
import { qsToTitle as qsToTitle15 } from "../../src/team-planner15/TbPage15.bs";
import { qsToTitle as qsToTitle16 } from "../../src/team-planner16/TbPage16.bs";
import { qsToTitle as qsToTitle17 } from "../../src/team-planner17/TbPage17.bs";
import { qsToTitle as qsToTitle76 } from "../../src/team-planner76/TbPage76.bs";

export default function TeamBuilder({ board = "", locale }) {
  const content = `https://u.tft.tools/screenshot/team-builder/${
    locale == "en" ? "" : `${locale}/`
  }${board}`;

  let title = "";
  let set = "14";

  try {
    const title10 = qsToTitle10(board);
    const title13 = qsToTitle13(board);
    const title14 = qsToTitle14(board);
    const title15 = qsToTitle15(board);
    const title16 = qsToTitle16(board);
    const title17 = qsToTitle17(board);
    const title76 = qsToTitle76(board);

    let maxLen = Math.max(
      title10.length,
      title13.length,
      title14.length,
      title15.length,
      title16.length,
      title17.length,
      title76.length,
    );
    if (title17.length === maxLen) {
      title = title17;
      set = "17";
    } else if (title16.length === maxLen) {
      title = title16;
      set = "16";
    } else if (title15.length === maxLen) {
      title = title15;
      set = "15";
    } else if (title76.length === maxLen) {
      title = title76;
      set = "7";
    } else if (title14.length === maxLen) {
      title = title14;
      set = "14";
    } else if (title13.length === maxLen) {
      title = title13;
      set = "13";
    } else if (title10.length === maxLen) {
      title = title10;
      set = "10";
    }
  } catch (_) {}

  return (
    <>
      <Head>
        <meta content={title} property="og:title" />
        <meta property="og:image" content={content} />
        <meta name="twitter:card" content="summary_large_image" />
        <title>{`${title} - TFT Team Builder Set ${set}`}</title>
      </Head>
      <TeamBuilderPage locale={locale} initialBoard={board} />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ locale, params }) {
  return {
    props: {
      board: params.board,
      locale,
    },
  };
}
